import {ModelApi} from '@/api/model.api.js'
import {User} from '@/models/user.model.js'

/**
 * User API service
 *
 * NOTE: This API is for the current user (singular)
 */
export class UserApi extends ModelApi {

  //Props
  basePath = '/api/v1/user'
  itemKey = 'user'
  ModelClass = User

  /**
   * Get current user
   */
  getCurrent() {
    return this
      .get(`/`)
      .then(json => this.toModelInstance(json))
  }

  /**
   * Update current user
   */
  update(data) {
    return this
      .patch(`/`, {[this.itemKey]: data})
      .then(json => this.toModelInstance(json))
  }

  /**
   * Get preview enrollment for current user by course ID
   */
  previewEnrollment(params) {
    return this
      .get(`/preview_enrollment`, params)
  }
}

//Export singleton instance
export const userApi = new UserApi()
